import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '24px 0 8px 0',
    color: (props) => (props.eventStyles.font_color ? props.eventStyles.font_color : '#4A4A4A'),
    '& a': {
      color: (props) => (props.eventStyles.font_color ? props.eventStyles.font_color : '#4A4A4A'),
    },
    backgroundPosition: 'bottom center',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
  },
  sectionEo: {
    display: 'flex',
  },
  section2: {
    marginTop: 12,
  },
  imgEo: {
    flex: '0 0 auto',
  },
  infoEo: {
    flex: '1 1 auto',
    paddingLeft: '8px',
  },
  title: {
    fontSize: '1.125rem',
    fontWeight: 500,
    lineHeight: '1.5rem',
  },
  iconSection: {
    display: 'inline-block',

    marginLeft: 8,
    '&:first-child': {
      marginLeft: 0,
    },
  },
  icon: {
    width: '30px',
    height: '30px',
  },
  iconSmall: {
    width: '16px',
    height: '16px',
    position: 'relative',
    top: '4px',
    marginRight: '4px',
  },
  text: {
    display: 'inline-block',
  },
  button: {
    padding: '3px 8px',
    minWidth: '94px',
    fontSize: '0.875rem',
    lineHeight: '1.125rem',
    backgroundColor: '#00B070',
    color: '#FFF',
    borderRadius: '50px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#007F51',
      color: '#FFF',
    },
  },
  boxContact: { display: 'flex', alignItems: 'baseline' },
  boxIconContact: { flex: '0 0 auto' },
  boxTextContact: {
    flex: '1 1 auto',

    fontSize: '0.625rem',
    lineHeight: '0.8125rem',
    wordBreak: 'break-all',
  },
}))

export default useStyles
